import React, { ReactNode } from 'react';
import captureException from '../../utils/captureException';

export type ErrorBoundaryProps = {
  children: React.ReactNode;
  fallbackUI: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown): void {
    captureException(error);
  }

  render() {
    const { hasError } = this.state;
    const { children, fallbackUI } = this.props;
    return hasError
      ? fallbackUI
      : children;
  }
}

export default ErrorBoundary;
